module.exports = __webpack_public_path__ + "img/virusColectivo6.619979c8.jpg";